import { render, staticRenderFns } from "./parameter.vue?vue&type=template&id=36edc762&scoped=true&"
import script from "./parameter.vue?vue&type=script&lang=js&"
export * from "./parameter.vue?vue&type=script&lang=js&"
import style0 from "./parameter.vue?vue&type=style&index=0&id=36edc762&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36edc762",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSelect,VTextField,VTooltip})
